// removed by extract-text-webpack-plugin
module.exports = {"button":"_3QpD0","info":"_3iRaz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/DownloadImages.css
// module id = 825
// module chunks = 0